import {Routes} from '@angular/router';
import {LoginComponent} from "./login.component";
import {NoAuthGuard} from "../guards/no-auth/no-auth.guard";

export const LoginRoutes: Routes = [
  {
    path: 'login', component: LoginComponent, canActivate: [NoAuthGuard]
  }
];
